import { Component } from '@poa/core';
import { observable } from 'mobx';
import { Observer } from 'mobx-react';
import React from 'react';
import { SingleDatePicker } from 'react-dates';
import { PrefetchSelect } from './profile-modal/tabs/profile-tab-form';
import { PageModeTransfers } from './table-filter';
import moment from 'moment';
import 'react-time-picker/dist/TimePicker.css';
import TimePicker from 'react-time-picker';

class _AddTransferModal extends React.Component {
  localState = observable({
    selectedFrom: this.props.from || null,
    selectedTo: this.props.to || null,
    selectedDate: this.props.date || moment().utc(),
    selectedAccountId: this.props.accountId || null,
    currentMode: this.props.initialMode,
    manageMode: this.props.manageMode,
    isDatePickerOpen: false
  });

  onTimeChange = (value) => {
    this.localState.selectedDate = this.localState.selectedDate.hour(value.substring(0, 2)).minute(value.substring(3, 5));
  };

  onDateChange = (value) => {
    this.localState.selectedDate = value.hour(this.localState.selectedDate.hours()).minute(this.localState.selectedDate.minutes());
  };

  handleDatepickerFocusChange = ({ focused }) => (this.localState.isDatePickerOpen = focused);

  getSelectsFetchDataType() {
    switch (this.localState.currentMode) {
      case PageModeTransfers.teamlead:
        return 'transfer_teamleads';
      case PageModeTransfers.operator:
        return 'transfer_operators';
      case PageModeTransfers.manager:
        return 'transfer_managers';
      default:
        throw new Error('[AddTransferModal]: Unknown mode type');
    }
  }

  getSelectedTypeTranslate() {
    switch (this.localState.currentMode) {
      case PageModeTransfers.teamlead:
        return 'Тимлидами';
      case PageModeTransfers.operator:
        return 'Операторами';
      case PageModeTransfers.manager:
        return 'Менеджерами';
      default:
        throw new Error('[AddTransferModal]: Unknown mode type');
    }
  }

  onSave = event => {
    event.preventDefault();

    if (this.localState.manageMode === 'add') {
      this.props.onSave({
        from: this.localState.selectedFrom,
        to: this.localState.selectedTo,
        date: this.localState.selectedDate.format('DD.MM.YYYY HH:mm'),
        type: this.localState.currentMode,
        accountId: this.localState.selectedAccountId
      });
    } else {
      this.props.onUpdate({
        from: this.localState.selectedFrom,
        to: this.localState.selectedTo,
        date: this.localState.selectedDate.format('DD.MM.YYYY HH:mm'),
        type: this.localState.currentMode,
        accountId: this.localState.selectedAccountId,
        transferId: this.props.transferId
      });
    }
  };

  onDelete = event => {
    event.preventDefault();

    this.props.onDelete(this.props.transferId);
  };

  render() {
    return (
      <div>
        {this.localState.manageMode === 'add' && (
          <div style={{textAlign: 'center'}}>
            Перевод между: <strong><br/>{this.getSelectedTypeTranslate()}</strong>
          </div>
        )}
        <Observer>
          {() => (
            <div>
              Аккаунт:
              <PrefetchSelect
                key={this.localState.currentMode}
                editMode={true}
                current={this.localState.selectedAccountId}
                type='accounts/list'
                transformResponse={response => response.data}
                titleExtractor={item => item.login}
                onChange={value => (this.localState.selectedAccountId = value)}
              />
            </div>
          )}
        </Observer>
        <Observer>
          {() => (
            <div>
              От кого:
              <PrefetchSelect
                key={this.localState.currentMode}
                editMode={true}
                current={this.localState.selectedFrom}
                type={this.getSelectsFetchDataType()}
                onChange={value => (this.localState.selectedFrom = value)}
              />
            </div>
          )}
        </Observer>
        <Observer>
          {() => (
            <div>
              К кому:
              <PrefetchSelect
                key={this.localState.currentMode}
                editMode={true}
                current={this.localState.selectedTo}
                type={this.getSelectsFetchDataType()}
                onChange={value => (this.localState.selectedTo = value)}
              />
            </div>
          )}
        </Observer>
        <Observer>
          {() => (
            <div className='picker-wrapper'>
              Дата:
              <br />
              <SingleDatePicker
                block
                isOutsideRange={() => false}
                placeholder='Виберите дату'
                key={this.localState.currentMode}
                focused={this.localState.isDatePickerOpen}
                displayFormat='DD.MM.YYYY'
                date={this.localState.selectedDate}
                onDateChange={this.onDateChange}
                onFocusChange={this.handleDatepickerFocusChange}
              />
            </div>
          )}
        </Observer>
        <Observer>
          {() => (
            <div className='picker-wrapper'>
              Время:
              <br />
              <TimePicker
                className='time_picker'
                onChange={this.onTimeChange}
                value={moment(this.localState.selectedDate).format('HH:mm')}
                disableClock={true}
                openClockOnFocus={false}
                format='HH:mm'
              />
            </div>
          )}
        </Observer>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '15px',
          gap: '100px'
        }}>

          <button
            className='filter-columns__save'
            style={{
              padding: '10px 16px',
              margin: '0',
              color: 'red',
              display: this.localState.manageMode === 'add' ? 'none' : 'inherit'
            }}
            onClick={this.onDelete}
          >
            удалить
          </button>

          <button
            type='submit'
            className='filter-columns__save'
            style={{ padding: '10px 16px', margin: '0' }}
            onClick={this.onSave}
          >
            {this.localState.manageMode === 'add' ? 'добавить' : 'изменить'}
          </button>
        </div>
      </div>
    );
  }
}

export const AddTransferModal = Component()(_AddTransferModal);
